module.exports = __webpack_public_path__ + "img/gemini.d1d333e7.png";